<template>
<div class="w-full p-2 bg-blue-600 sm:p-8" style="height: 100dvh">
  <div class="flex w-full h-full bg-white rounded-3xl overflow-hidden">

    <div class="flex-grow flex flex-col items-start overflow-auto sm:p-12" style="padding: 8%">

      <img
        src="@/assets/TheTutorIndex-logo-horizontal.svg"
        class="mt-2 w-40 self-auto sm:mt-0 md:self-auto"
      />

      <div 
        class="mt-6 items-center w-full h-6"
        :class="[$route.name !== 'FindATutor-Initial' ? 'flex' : 'hidden']"
      >
        <button
          v-show="$route.name !== 'FindATutor-ThankYou'"
          type="button" 
          @click="$router.back()"
          class="py-1 pr-3"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="w-4 h-4 text-gray-500"><path d="M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z" fill="currentColor" /></svg>
        </button>
        <div class="w-full h-1 bg-gray-200">
          <div
            class="h-1 bg-blue-500 transition-all rounded"
            :class="stepClass"
          ></div>
        </div>
      </div>

      <!-- <h1 class="flex-grow flex flex-col justify-end text-3xl text-gray-700 font-extrabold leading-snug md:text-5xl md:leading-snug">
        Find the perfect
        <br class="hidden md:inline" />
        tutor for you
      </h1> -->

      <div class="mt-8 flex-grow w-full sm:mt-16" style="flex-grow: 3; flex-basis: 50%;">
        <router-view
          :enquiry="enquiry"
          @updateEnquiry="updateEnquiry"
        />
      </div>
<!-- {{ enquiry }} -->
      <!-- <img
        src="@/assets/TheTutorIndex-logo-horizontal.svg"
        class="mt-14 w-40 self-center md:self-auto"
      /> -->
    </div>

    <div class="hidden w-2/5 h-full lg:block">
      <!-- 
        src="https://images.unsplash.com/photo-1445743432342-eac500ce72b7?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
       -->
      <img
        src="@/assets/pexels-pavel-danilyuk-7352051.jpg"
        class="h-full object-cover"
        style="object-position: 30%"
      />
    </div>

  </div>
</div>
</template>
<script>
export default {
  data() {
    return {
      enquiry: {},
    }
  },
  computed: {
    stepClass() {
      switch (this.$route.name) {
        case 'FindATutor-Initial': return 'w-1/6'
        case 'FindATutor-Subject': 
        case 'FindATutor-Level': return 'w-2/6'
        case 'FindATutor-Location': return 'w-3/6'
        case 'FindATutor-Rate': return 'w-4/6'
        case 'FindATutor-Message': return 'w-5/6'
        case 'FindATutor-PersonalInfo': return 'w-6/6'
      }
    }
  },
  methods: {
    updateEnquiry(payload) {
      this.enquiry = { ...this.enquiry, ...payload }
    }
  },
  mounted() {
    if (this.$route.name !== 'FindATutor-Initial') this.$router.push({ name: 'FindATutor-Initial' })
  }
}
</script>
